<template>
  <chart ref="chart" :options="chartOptions" />
</template>
<script>
import { Chart } from 'highcharts-vue'
import { map } from 'lodash'

export default {
  components: {
    Chart,
  },
  props: ['title', 'subtitle', 'data'],
  data() {
    return {
      loading: false,
      chartOptions: {
        chart: {
          height: 375,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
            marker: {
              radius: 0,
              states: {
                hover: {
                  radiusPlus: 4,
                },
              },
            },
          },
        },
        xAxis: {
          title: {
            text: 'Perióda',
          },
          min: 1,
          tickInterval: 1,
        },
        yAxis: {
          title: {
            text: 'Cena (€ bez dph/MWh)',
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: 2,
          valueSuffix: ' € bez dph/MWh',
        },
        series: [
          {
            name: 'Cena (€ bez dph/MWh)',
            color: '#6fa55a',
            data: [],
            negativeColor: '#FF0000',
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'trhove-ceny-okte',
        },
      },
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.chartOptions.series[0].data = this.data
      },
      //this.chartOptions.series[0].data = this.data.values
    },
  },
  mounted() {},
}
</script>
